import React from "react";
import LogoMarkSrc from "@/assets/TerraMatrix_LogoMark.svg";
import { cn } from "@/lib/utils";

interface TerraMatrixLogoMarkProps {
  className?: string;
}

interface TerraMatrixBrandProps {
  className?: string;
  markClassName?: string;
  nameClassName?: string;
  showName?: boolean;
}

export const TerraMatrixLogoMark: React.FC<TerraMatrixLogoMarkProps> = ({
  className,
}) => (
  <img
    src={LogoMarkSrc}
    alt=""
    aria-hidden="true"
    className={cn("block h-8 w-8 flex-none", className)}
  />
);

export const TerraMatrixBrand: React.FC<TerraMatrixBrandProps> = ({
  className,
  markClassName,
  nameClassName,
  showName = true,
}) => (
  <span className={cn("inline-flex items-center gap-2.5", className)}>
    <TerraMatrixLogoMark className={markClassName} />
    {showName ? (
      <span
        className={cn(
          "text-lg font-semibold tracking-tight text-foreground",
          nameClassName,
        )}
      >
        TerraMatrix
      </span>
    ) : null}
  </span>
);
